// import React, { useState, useEffect } from "react";
// import { useHistory } from 'react-router-dom';
// import { connect } from "react-redux";
// import axios from "axios";
// import { NavLink } from "react-bootstrap";
// import ConfirmDeleteModal from './ConfirmationModelDelete';
// import { saveAs } from 'file-saver';
// import { Parser } from 'json2csv';

// const VratList = () => {
//   const [categories, setCategories] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCategoryId, setSelectedCategoryId] = useState(null);
//   const history = useHistory();
//   const token = localStorage.getItem('authToken');
//   const getData = async () => {
//     try {
//       const response = await axios.get(`https://samaj.aasmo.in/api/admin/vrat?page=${currentPage}&search=${searchQuery}`,{
//         headers: {
//           Authorization: `Bearer ${token}`,
          
//       }
//       });
//     //   console.log(response.data)
//       setCategories(response.data.Varat);
//       setTotalPages(response.data.totalPages);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const handleEdit = (id) => {
//     history.push(`/editvrat/${id}`);
//   };

//   const handleDelete = async (id) => {
//     try {
//       const response = await axios.delete(`https://samaj.aasmo.in/api/admin/vrat/${id}`,{
//         headers: {
//           Authorization: `Bearer ${token}`,
          
//       }
//       });
//       if (response) {
//         console.log("Deleted Successfully");
//         getData();
//       }
//     } catch (error) {
//       console.log(error);
//     }
//     setShowModal(false);
//   };

//   const handleDeleteClick = (id) => {
//     setSelectedCategoryId(id);
//     setShowModal(true);
//   };

//   useEffect(() => {
//     getData();
//   }, [currentPage, searchQuery]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleDownload = () => {
//     const fields = [
//       "id", "title", "category.name","  subcategory.name","image" ,"description", "createdAt"
//   ];
//   const json2csvParser = new Parser({ fields });
//   const csv = json2csvParser.parse(categories);
//   const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//     saveAs(blob, 'vratAurTyohar_list.csv');
// }


// const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
// };
// const formatDescription = (description) => {
//   return description.length > 10 ? description.slice(0, 10) + '...' : description;
// };
//   return (
//     <div className="col-lg-12">
//       <div className="card">
//         <div className="header">
//           <h2>Vrat Aur Tyohar List</h2>
//         </div>
//         <div className="d-flex justify-content-start">
//           <div className="input-group m-b-10 col-lg-3">
//             <div className="input-group-prepend">
//               <span className="input-group-text">
//                 <i className="icon-magnifier"></i>
//               </span>
//             </div>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search By Title"
//               value={searchQuery}
//               onChange={handleSearch}
//             />
//           </div>
//           <div>
//           <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
//           </div>
//         </div>
//         <div className="body table-responsive">
//           <table className="table table-hover">
//             <thead style={{textAlign:"center"}}>
//               <tr>
//                 <th>S.No</th>
//                 <th>Sub Category Name</th>
//                 <th>Sub Sub Category Name</th>
//                 <th>Title</th>
             
//                 <th>Image</th>
               
//                 <th>Description</th>
//                 <th>Date</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody style={{textAlign:"center"}} >
//               {categories.map((category, index) => {
//                 const statusClass = category.status === 'no' ? 'text-danger' : category.status === 'yes' ? 'text-success' : 'text-primary';

//                 return (
//                   <tr key={category.id}>
//                     <td>{(currentPage - 1) * 10 + index + 1}</td>
//                     {/* <td>{category.registeredUser.fullName}</td> */}
//                     <td>{formatDescription(category?.category?.name)}</td>
//                     <td>{formatDescription(category?.subcategory?.name)}</td>
//                     <td>{category?.title}</td>
                  
//                     <td>
//                       <img src={`https://uma-classees.blr1.digitaloceanspaces.com/${category.image}`} width={50} height={50} className="rounded-circle user-photo" alt="Category" />
//                     </td>
                   
//                     <td>{formatDescription(category.description)}</td>
                 
//                     <td> {formatDate(category.createdAt)}</td>
//                     <td>
//                       <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
//                       &nbsp;&nbsp;
//                       <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//         <div className="body">
//           <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
//             <ul className="pagination">
//               <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage - 1)}
//                 >
//                   Previous
//                 </NavLink>
//               </li>
//               {[...Array(totalPages).keys()].map(page => (
//                 <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
//                   <NavLink
//                     to="#"
//                     className="page-link"
//                     onClick={() => handlePageChange(page + 1)}
//                   >
//                     {page + 1}
//                   </NavLink>
//                 </li>
//               ))}
//               <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage + 1)}
//                 >
//                   Next
//                 </NavLink>
//               </li>
//             </ul>
//           </nav>
//         </div>
//       </div>
//       <ConfirmDeleteModal
//         show={showModal}
//         handleClose={() => setShowModal(false)}
//         handleConfirm={() => handleDelete(selectedCategoryId)}
//       />
//     </div>
//   );
// };

// const mapStateToProps = ({ mailInboxReducer }) => ({});

// export default connect(mapStateToProps, {})(VratList);


import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';

const VratList = () => {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/vrat?page=${currentPage}&search=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      // --- CHANGE 1: Safety check for API response ---
      if (response.data && Array.isArray(response.data.varat)) {
        setCategories(response.data.varat);
        setTotalPages(response.data.totalPages);
      } else {
        setCategories([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.log(error);
      setCategories([]);
      setTotalPages(1);
    }
  };

  const handleEdit = (id) => {
    history.push(`/editvrat/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://samaj.aasmo.in/api/admin/vrat/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      if (response) {
        console.log("Deleted Successfully");
        getData();
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedCategoryId(id);
    setShowModal(true);
  };

  useEffect(() => {
    getData();
  }, [currentPage, searchQuery]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setCurrentPage(1);
    setSearchQuery(e.target.value);
  };

  const handleDownload = () => {
    const fields = ["id", "title", "category.name", "subcategory.name", "image", "description", "createdAt"];
    const json2csvParser = new Parser({ fields });
    const csv = json2csvParser.parse(categories);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'vratAurTyohar_list.csv');
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatDescription = (description) => {
    if (!description) return '';
    return description.length > 20 ? description.slice(0, 20) + '...' : description;
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Vrat Aur Tyohar List</h2>
        </div>
        <div className="d-flex justify-content-start">
          <div className="input-group m-b-10 col-lg-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Title"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
          <div>
            <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center" }}>
              <tr>
                <th>S.No</th>
                <th>Sub Category Name</th>
                <th>Sub Sub Category Name</th>
                <th>Title</th>
                <th>Image</th>
                <th>Description</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {/* --- CHANGE 2: Safety check for rendering --- */}
              {Array.isArray(categories) && categories.map((category, index) => (
                <tr key={category.id}>
                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                  <td>{formatDescription(category?.category?.name)}</td>
                  <td>{formatDescription(category?.subcategory?.name)}</td>
                  <td>{category?.title}</td>
                  <td>
                    {/* --- CHANGE 3: Use the full URL from the API --- */}
                    <img src={category.image} width={50} height={50} className="rounded-circle user-photo" alt="Vrat" />
                  </td>
                  <td>{formatDescription(category.description)}</td>
                  <td>{formatDate(category.createdAt)}</td>
                  <td>
                    <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
                      
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedCategoryId)}
      />
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(VratList);